<template>
  <div class="log">
    <button
      v-permissions="'view-details-jobs'"
      @click.stop="dialog = false"
      @click="getAssignments"
      title="View Assignments"
      target="_blank"
      class="view-ass-btn"
    >
      View
    </button>

    <v-dialog
      v-model="dialog"
      max-width="1152"
      content-class="assignment-view-dialog"
    >
      <v-form ref="form">
        <v-card class="comments-view assignment-view-card">
          <header class="assignment-view-header">
            <div class="assignment-view-header__brand">
              <div class="assignment-view-header__badge" aria-hidden="true">
                <v-icon>assignment</v-icon>
              </div>
              <div class="assignment-view-header__copy">
                <h2 class="assignment-view-title">View Assignments</h2>
              </div>
            </div>
            <v-btn
              icon
              class="assignment-view-close"
              @click.prevent="dialog = false"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>

          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            class="assignment-view-progress"
            v-show="processing"
          ></v-progress-linear>

          <div class="assignment-view-scroll">
            <v-card-text class="nospace assignment-view-body">
              <v-stepper v-model="e1" class="no-transition assignment-view-stepper">
                <v-stepper-header class="SubTypeTab assignment-view-tabs">
                  <template v-for="n in steps" class="bg-clr-tab">
                    <v-stepper-step
                      :complete="e1 == n"
                      :key="`${n}-step`"
                      :step="n"
                      :editable="true"
                      color="orange darken-1"
                      :complete-icon="getModeIcon(jobTypeArray[n - 1])"
                      :edit-icon="getModeIcon(jobTypeArray[n - 1])"
                      class="bg-clr-tab assignment-view-tab"
                      :class="{
                        'assignment-view-tab--active': e1 == n,
                      }"
                    >
                      <span>{{ getJobType(jobTypeArray[n - 1]) }} </span>
                    </v-stepper-step>
                  </template>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content
                    v-for="n in steps"
                    :key="`${n}-content`"
                    :step="n"
                    class="assignment-view-step"
                  >
                    <v-flex>
                      <v-data-table
                        id="assignmentPopupTable"
                        :class="[
                          'procurement-assignment-popup-table',
                          Section == 'Sales'
                            ? 'procurement-assignment-popup-table--sales'
                            : '',
                        ]"
                        hide-actions
                        :headers="
                          getAssignmentHeaders(
                            jobTypeArray[n - 1],
                            Section == 'Sales'
                          )
                        "
                        v-if="tabArray.length"
                        :items="tabArray[n - 1].assignmentListing"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <span class="assignment-id-chip">{{
                              props.item.assignmentId
                            }}</span>
                          </td>
                          <td>
                            <span class="assignment-mode-chip">
                              <v-icon size="14">{{
                                getModeIcon(props.item.jobType)
                              }}</v-icon>
                              {{ getJobType(props.item.jobType) || "Land" }}
                            </span>
                          </td>

                          <td>
                            <span class="assignment-muted-value">{{
                              getUnitTypeText(props.item.jobType, props.item.truckType)
                            }}</span>
                          </td>
                          <td>
                            <span
                              class="assignment-status-chip"
                              :class="statusChipClass(props.item.assignmentStatus)"
                            >
                              {{
                                getModeAwareAssignmentStatus(
                                  props.item.assignmentStatus,
                                  props.item.jobType
                                )
                              }}
                            </span>
                          </td>
                          <td v-if="props.item.driverData && !Section">
                            <div class="assignment-driver">
                              <strong class="assignment-driver__name">
                                {{ props.item.driverData.name }}
                                <span class="assignment-driver__id"
                                  >({{ props.item.driverData.driverId }})</span
                                >
                              </strong>
                              <span class="assignment-driver__phone">
                                {{
                                  props.item.driverData.countryCode +
                                    "-" +
                                    props.item.driverData.phoneNo
                                }}
                              </span>
                            </div>
                          </td>
                          <td v-else-if="!Section">
                            <span class="assignment-empty">—</span>
                          </td>
                          <td v-if="props.item.driverData && !Section">
                            <span class="assignment-unit-chip">
                              <template v-if="props.item.truckPrefix">
                                {{ props.item.truckPrefix }}-{{
                                  props.item.truckNumber
                                }}
                              </template>
                              <template v-else>
                                {{ props.item.driverData.truckPrefix }}-{{
                                  props.item.driverData.truckNumber
                                }}
                              </template>
                            </span>
                          </td>
                          <td v-else-if="!Section">
                            <span class="assignment-empty">—</span>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
          </div>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      :timeout="6000"
      bottom
      color="red darken-2"
      v-model="x.error"
      class="white--text"
      v-if="x.error"
      >{{ x.error }}</v-snackbar
    >
  </div>
</template>
<script>
import moment from "moment";
import ErrorBox from "@/components/Common/ErrorBox";
import {
  jobListAssignmentpopup,
  jobListAssignmentpopupSales,
} from "@/constants/datatable-headers.js";
import {
  StorageKeys,
  TruckTypes,
  AirTypes,
  SeaTypes,
} from "../../constants/constants";
import DriverQuote from "./DriverQuote.vue";
import { procurement } from "../../constants/api-urls";
import {
  getOperatorDetailsLabel,
  getOperatorRoleLabel,
  getModeIcon,
  getUnitNoLabel,
  getUnitTypeLabel,
} from "@/utils/shipmentLabels";
export default {
  data() {
    return {
      truckTypes: TruckTypes,
      airTypes: AirTypes,
      seaTypes: SeaTypes,
      tabArray: [],
      e1: 1,
      steps: 1,
      jobType: null,
      x: {
        error: null,
      },
      items: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      headers: jobListAssignmentpopup,
      headersSales: jobListAssignmentpopupSales,
    };
  },
  props: {
    jobId: Number,
    Section: String,
  },
  created() {
    this.jobTypeArray = [];
  },
  components: {
    ErrorBox,
    DriverQuote,
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },
  methods: {
    getModeIcon,
    statusChipClass(status) {
      const code = Number(status);
      if (code === -1) return "assignment-status-chip--danger";
      if (code === 2 || code === 5) return "assignment-status-chip--info";
      if (code === 4 || code === 6) return "assignment-status-chip--success";
      if (code === 3) return "assignment-status-chip--warn";
      return "assignment-status-chip--neutral";
    },
    getModeAwareAssignmentStatus(status, mode) {
      const statusLabel = this.assignmentStatus(status) || "";
      return statusLabel.replace(/Driver/g, getOperatorRoleLabel(mode));
    },
    getAssignmentHeaders(mode, forSales = false) {
      const source = forSales ? this.headersSales : this.headers;
      return source.map((header) => {
        if (header.text === "Truck Type") {
          return { ...header, text: getUnitTypeLabel(mode) };
        }
        if (header.text === "Driver Details") {
          return { ...header, text: getOperatorDetailsLabel(mode) };
        }
        if (header.value === "truckNumber") {
          return { ...header, text: getUnitNoLabel(mode) };
        }
        return header;
      });
    },
    getText(arr = [], val) {
      if (val === null || val === undefined || val === "") {
        return "NA";
      }

      const finalEl = arr.find((el) => el.value === val.toString());

      return finalEl ? finalEl.text : "NA";
    },
    // The assignment's `truckType` code is an index into a different list per
    // mode: trucks for Land, flight types for Air, vessel types for Sea.
    getUnitTypeText(mode, val) {
      switch (String(mode)) {
        case "2":
          return this.getText(this.airTypes, val);
        case "3":
          return this.getText(this.seaTypes, val);
        default:
          return this.getText(this.truckTypes, val);
      }
    },
    getJobType(type) {
      switch (type) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },

    getTime(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Driver Not Assigned";
        case 2:
          return "Driver Assigned";
        case 3:
          return "Payment Pending";
        case 4:
          return "Payment Done";
        case 5:
          return "In-Transit";
        case 6:
          return "Shipment Offloaded ";
        case -1:
          return "Cancelled";
        default:
          return "Unknown";
      }
    },
    getAssignments() {
      console.log("this.jobId", this.jobId);
      if (!navigator.onLine) {
        this.loading = false;
        this.x.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }

      this.dialog = true;
      if (this.processing) {
        return;
      } else {
        this.processing = true;
        let url = procurement.jobDataForPopup;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          jobId: this.jobId.toString(),
        };
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.dialog = true;
            this.jobTypeArray = [];
            console.log(response);
            var size = response.data.data.assignmentList.length;
            this.steps = size;
            for (var i = 0; i < size; i++) {
              this.jobTypeArray[i] =
                response.data.data.assignmentList[i].jobType || "1";
            }
            this.tabArray = response.data.data.assignmentList;

            this.processing = false;
          },
          (error) => {
            this.x.error = "Failed to Fetch Assignments";
            this.processing = false;
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.v-stepper__header {
  justify-content: left !important;
}

.break_long_text {
  word-break: break-word;
  hyphens: auto;
}

.user {
  padding: 10px;
}

.comments-view .v-toolbar {
  width: 100%;
}

.v-toolbar--fixed {
  position: inherit;
}

.view-ass-btn {
  background: linear-gradient(160deg, #f58220 0%, #ea7a1c 100%);
  border: 0;
  border-radius: 0.5rem;
  box-shadow: 0 0.25rem 0.75rem rgba(234, 122, 28, 0.28);
  color: #ffffff;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  padding: 0.35rem 0.7rem;
  text-decoration: none;
}

.assignment-view-card {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.assignment-view-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.12), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #ebe9e2;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.7rem 1rem;
}

.assignment-view-header__brand {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  min-width: 0;
}

.assignment-view-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.3rem 0.7rem rgba(28, 43, 95, 0.2);
  color: #ffffff;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.25rem;
  justify-content: center;
  position: relative;
  width: 2.25rem;
}

.assignment-view-header__badge::after {
  background: #f58220;
  border-radius: 999px;
  bottom: 0.24rem;
  content: "";
  height: 0.18rem;
  left: 0.45rem;
  position: absolute;
  right: 0.45rem;
}

.assignment-view-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1rem !important;
  margin-top: -0.1rem;
}

.assignment-view-title {
  color: #1c2b5f;
  font-size: 0.975rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}

.assignment-view-close {
  color: #5b6475 !important;
}

.assignment-view-progress {
  margin: 0 !important;
}

.assignment-view-scroll {
  display: block;
  max-height: min(400px, calc(82vh - 7rem));
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: #c9c5bd transparent;
  scrollbar-width: thin;
}

.assignment-view-scroll::-webkit-scrollbar {
  width: 0.3125rem;
}

.assignment-view-scroll::-webkit-scrollbar-thumb {
  background: #c9c5bd;
  border-radius: 999px;
}

.assignment-view-body {
  max-height: none !important;
  overflow: visible !important;
  padding: 0.7rem 1rem 0.95rem !important;
}

.assignment-view-body ::v-deep .v-stepper {
  background: transparent !important;
  box-shadow: none !important;
}

.assignment-view-body ::v-deep .assignment-view-tabs.v-stepper__header {
  align-items: center;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  height: auto !important;
  justify-content: flex-start !important;
  margin-bottom: 0.55rem;
  padding: 0 !important;
}

.assignment-view-body ::v-deep .assignment-view-tab.v-stepper__step {
  background: #f6f5f2 !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 999px !important;
  flex: 0 0 auto !important;
  margin: 0 !important;
  min-height: 2rem !important;
  padding: 0.25rem 0.7rem 0.25rem 0.35rem !important;
}

.assignment-view-body ::v-deep .assignment-view-tab--active.v-stepper__step,
.assignment-view-body ::v-deep .assignment-view-tab.v-stepper__step--active {
  background: #fff7ed !important;
  border-color: #fdba74 !important;
  box-shadow: 0 0.25rem 0.75rem rgba(234, 122, 28, 0.12);
}

.assignment-view-body ::v-deep .assignment-view-tab .v-stepper__step__step {
  background: #1c2b5f !important;
  color: #ffffff !important;
  height: 1.5rem !important;
  margin-right: 0.45rem !important;
  min-width: 1.5rem !important;
  width: 1.5rem !important;
}

.assignment-view-body
  ::v-deep
  .assignment-view-tab--active
  .v-stepper__step__step,
.assignment-view-body
  ::v-deep
  .assignment-view-tab.v-stepper__step--active
  .v-stepper__step__step {
  background: linear-gradient(160deg, #f58220 0%, #ea7a1c 100%) !important;
}

.assignment-view-body ::v-deep .assignment-view-tab .v-stepper__label {
  color: #1c2b5f !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
}

.assignment-view-body ::v-deep .assignment-view-tabs .v-divider {
  display: none !important;
}

.assignment-view-body ::v-deep .assignment-view-step.v-stepper__content {
  margin: 0 !important;
  padding: 0 !important;
}

.assignment-view-body ::v-deep .v-table__overflow {
  max-width: 100%;
  overflow-x: auto !important;
  overflow-y: visible !important;
}

.tabsPadding {
  padding: 9px !important;
}

.no-transition .stepper__content {
  transition: none;
}

.procurement-assignment-popup-table ::v-deep table.v-table {
  background: transparent !important;
  border-collapse: separate !important;
  border-spacing: 0 0.35rem !important;
  table-layout: fixed;
  width: 100%;
}

.procurement-assignment-popup-table ::v-deep table.v-table thead tr {
  background: transparent !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table thead th {
  background: #fff7ed !important;
  border: 0 !important;
  border-bottom: 0.0625rem solid #fed7aa !important;
  color: #c35f02 !important;
  -webkit-text-fill-color: #c35f02 !important;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.03em !important;
  padding: 0.55rem 0.7rem !important;
  text-transform: uppercase !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table thead th:first-child {
  border-radius: 0.65rem 0 0 0.65rem !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table thead th:last-child {
  border-radius: 0 0.65rem 0.65rem 0 !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table thead th .v-icon,
.procurement-assignment-popup-table ::v-deep table.v-table thead th span {
  color: #c35f02 !important;
  -webkit-text-fill-color: #c35f02 !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table tbody tr {
  background: transparent !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table tbody td {
  background: #ffffff !important;
  border-bottom: 0.0625rem solid #ebe9e2 !important;
  border-top: 0.0625rem solid #ebe9e2 !important;
  box-sizing: border-box;
  color: #3a382f !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  overflow-wrap: break-word;
  padding: 0.7rem 0.7rem !important;
  vertical-align: middle !important;
  white-space: normal;
  word-break: normal;
}

.procurement-assignment-popup-table ::v-deep table.v-table tbody td:first-child {
  border-left: 0.0625rem solid #ebe9e2 !important;
  border-radius: 0.75rem 0 0 0.75rem !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table tbody td:last-child {
  border-radius: 0 0.75rem 0.75rem 0 !important;
  border-right: 0.0625rem solid #ebe9e2 !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table tbody tr:hover td {
  background: #fffaf4 !important;
  border-color: #fdba74 !important;
}

.procurement-assignment-popup-table ::v-deep table.v-table th:nth-child(1),
.procurement-assignment-popup-table ::v-deep table.v-table td:nth-child(1) {
  width: 16%;
}

.procurement-assignment-popup-table ::v-deep table.v-table th:nth-child(2),
.procurement-assignment-popup-table ::v-deep table.v-table td:nth-child(2) {
  width: 14%;
}

.procurement-assignment-popup-table ::v-deep table.v-table th:nth-child(3),
.procurement-assignment-popup-table ::v-deep table.v-table td:nth-child(3),
.procurement-assignment-popup-table ::v-deep table.v-table th:nth-child(4),
.procurement-assignment-popup-table ::v-deep table.v-table td:nth-child(4) {
  width: 16%;
}

.procurement-assignment-popup-table ::v-deep table.v-table th:nth-child(5),
.procurement-assignment-popup-table ::v-deep table.v-table td:nth-child(5) {
  width: 24%;
}

.procurement-assignment-popup-table ::v-deep table.v-table th:nth-child(6),
.procurement-assignment-popup-table ::v-deep table.v-table td:nth-child(6) {
  width: 14%;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table th:nth-child(1),
.procurement-assignment-popup-table--sales ::v-deep table.v-table td:nth-child(1) {
  width: 25%;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table th:nth-child(2),
.procurement-assignment-popup-table--sales ::v-deep table.v-table td:nth-child(2) {
  width: 22%;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table th:nth-child(3),
.procurement-assignment-popup-table--sales ::v-deep table.v-table td:nth-child(3) {
  width: 25%;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table th:nth-child(4),
.procurement-assignment-popup-table--sales ::v-deep table.v-table td:nth-child(4) {
  width: 28%;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table thead th {
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa !important;
  color: #9a4f08 !important;
  -webkit-text-fill-color: #9a4f08 !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
  text-align: center !important;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table thead th .v-icon,
.procurement-assignment-popup-table--sales ::v-deep table.v-table thead th span {
  color: #9a4f08 !important;
  -webkit-text-fill-color: #9a4f08 !important;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table thead th:first-child,
.procurement-assignment-popup-table--sales ::v-deep table.v-table thead th:last-child {
  border-radius: 0 !important;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table thead tr {
  background: #fff7ed !important;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table tbody td {
  border-bottom: 0.0625rem solid #ebe9e2 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0 !important;
  border-radius: 0 !important;
  text-align: center !important;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table tbody td:first-child,
.procurement-assignment-popup-table--sales ::v-deep table.v-table tbody td:last-child {
  border-left: 0 !important;
  border-radius: 0 !important;
  border-right: 0 !important;
}

.procurement-assignment-popup-table--sales ::v-deep table.v-table tbody tr:hover td {
  background: #fffaf4 !important;
  border-color: #ebe9e2 !important;
}

.assignment-id-chip {
  color: #1c2b5f;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8125rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.assignment-mode-chip {
  align-items: center;
  background: #f4f7fb;
  border: 0.0625rem solid #d7e0f0;
  border-radius: 999px;
  color: #1c2b5f;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 800;
  gap: 0.3rem;
  padding: 0.28rem 0.55rem;
}

.assignment-mode-chip .v-icon {
  color: #ea7a1c !important;
  font-size: 0.875rem !important;
}

.assignment-muted-value {
  color: #3a382f;
  font-weight: 600;
}

.assignment-status-chip {
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1.2;
  max-width: 100%;
  padding: 0.35rem 0.6rem;
  white-space: normal;
}

.assignment-status-chip--info {
  background: #eaf1fd;
  color: #2456b8;
}

.assignment-status-chip--success {
  background: #e8f5ee;
  color: #12764c;
}

.assignment-status-chip--warn {
  background: #fff7ed;
  color: #c35f02;
}

.assignment-status-chip--danger {
  background: #fbeae8;
  color: #be3b32;
}

.assignment-status-chip--neutral {
  background: #f6f5f2;
  color: #5b6475;
}

.assignment-driver {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.assignment-driver__name {
  color: #1a1916;
  font-size: 0.8125rem;
  font-weight: 800;
  line-height: 1.3;
}

.assignment-driver__id {
  color: #5b6475;
  font-weight: 600;
}

.assignment-driver__phone {
  color: #74716a;
  font-size: 0.75rem;
  font-weight: 600;
}

.assignment-unit-chip {
  background: #fff7ed;
  border: 0.0625rem solid #fdba74;
  border-radius: 0.5rem;
  color: #9a4f08;
  display: inline-flex;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  padding: 0.3rem 0.55rem;
}

.assignment-empty {
  color: #b4b0a6;
  font-weight: 700;
}

html.oms-night-mode .application .assignment-view-card {
  background: var(--oms-surface) !important;
  border-color: var(--oms-border) !important;
}

html.oms-night-mode .application .assignment-view-header {
  background: linear-gradient(
    135deg,
    rgba(234, 122, 28, 0.16) 0%,
    var(--oms-surface) 55%,
    var(--oms-surface-soft) 100%
  );
  border-color: var(--oms-border);
}

html.oms-night-mode .application .assignment-view-title {
  color: #f8bd82;
}

@media (max-width: 40rem) {
  .assignment-view-header {
    padding: 0.65rem 0.85rem;
  }

  .assignment-view-body {
    padding: 0.6rem 0.75rem 0.85rem !important;
  }
}
</style>

<style>
.application .v-dialog.assignment-view-dialog {
  border-radius: 1rem !important;
  max-height: calc(100vh - 2rem) !important;
  max-width: min(72rem, calc(100vw - 2rem)) !important;
  overflow: hidden !important;
  width: 100%;
}

.application .assignment-view-dialog .assignment-view-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 2rem);
  min-height: 0;
  overflow: hidden !important;
}

.application .assignment-view-dialog .assignment-view-scroll {
  flex: 1 1 auto;
  max-height: none;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.application .assignment-view-dialog .assignment-view-body,
.application .assignment-view-dialog .v-stepper,
.application .assignment-view-dialog .v-stepper__items,
.application .assignment-view-dialog .v-stepper__content,
.application .assignment-view-dialog .v-stepper__wrapper {
  max-width: 100%;
}

.application .assignment-view-dialog .v-table__overflow {
  max-width: 100%;
  overflow-x: auto !important;
  overflow-y: visible !important;
  scrollbar-color: #c9c5bd transparent;
  scrollbar-width: thin;
}

.application .assignment-view-dialog .v-table__overflow::-webkit-scrollbar {
  height: 0.375rem;
}

.application .assignment-view-dialog .v-table__overflow::-webkit-scrollbar-track {
  background: transparent;
}

.application .assignment-view-dialog .v-table__overflow::-webkit-scrollbar-thumb {
  background: #c9c5bd !important;
  border-radius: 999rem;
}

.application
  .assignment-view-dialog
  .procurement-assignment-popup-table
  table.v-table {
  min-width: 56.25rem !important;
  table-layout: fixed !important;
  width: 100% !important;
}

.application
  .assignment-view-dialog
  .procurement-assignment-popup-table--sales
  table.v-table {
  min-width: 36rem !important;
}

.application
  .v-dialog.assignment-view-dialog
  .procurement-assignment-popup-table
  table.v-table
  thead
  th,
.application
  .v-dialog.assignment-view-dialog
  .comments-view
  .procurement-assignment-popup-table
  table.v-table
  thead
  th {
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa !important;
  color: #c35f02 !important;
  -webkit-text-fill-color: #c35f02 !important;
}

.application
  .v-dialog.assignment-view-dialog
  .procurement-assignment-popup-table
  table.v-table
  thead
  th
  span,
.application
  .v-dialog.assignment-view-dialog
  .procurement-assignment-popup-table
  table.v-table
  thead
  th
  .v-icon {
  color: #c35f02 !important;
  -webkit-text-fill-color: #c35f02 !important;
}

@media (max-width: 40rem) {
  .application .v-dialog.assignment-view-dialog {
    max-height: calc(100vh - 1rem) !important;
    max-width: calc(100vw - 1rem) !important;
    margin: 0.5rem !important;
  }

  .application .assignment-view-dialog .assignment-view-card {
    max-height: calc(100vh - 1rem);
  }
}
</style>
